<!-- letter of the event code -->
<span>{{ prefix() }}</span>

<!-- numbers of the event code -->
@for ( item of numbers(); track $index; let i = $index ) {
<fz-odometer-number [number]="item"></fz-odometer-number>
}

<!-- info icon -->
<span class="info_tooltip_icon" matTooltip="Info about the card"></span>
